"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CIVITAVECCHIA_LOCATION_ID = void 0;
exports.CIVITAVECCHIA_LOCATION_ID = "29540d21-6224-45e2-bd0e-e851a9d1fcde";
//# sourceMappingURL=locations.js.map